import { UserLoginPlot } from "./UserLogin";
import { UserTimePlot } from "./UserTime";
import { CumTopActionPlot } from "./TopActions";
import { CumCodeRelatedPlot } from "./CodeRelated";
import PDFTypeWatchTimeComponent from "./PDFType";
import SinglePDFWatchTimeComponent from "./SinglePDFs";
import { SessionActivity } from "./interface";
import { DailyPlot } from "./SessionDaily";
// plots components

export const renderPlot = (selectedPlot:string, sessionActivities:SessionActivity[]) => {
    switch (selectedPlot) {
      case "CumUserLoginPlot":
        return <UserLoginPlot sessionActivities={sessionActivities}  />;
      case 'SessionPlot':
        return <DailyPlot interactions={sessionActivities} />;
      case 'UserTimePlot':
        return <UserTimePlot sessionActivities={sessionActivities} />;
      case 'CumTopAction1Plot':
        return <CumTopActionPlot sessionActivities={sessionActivities} />;
      case 'CumCodeRelatedPlot':
        return <CumCodeRelatedPlot sessionActivities={sessionActivities} />;
      case 'PDFTypeWatchTime':
        return <PDFTypeWatchTimeComponent interactions = {sessionActivities}/>;
      case 'SinglePDFWatchTime':
      default:
        return <SinglePDFWatchTimeComponent interactions={sessionActivities} />;
    }
  };